import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <div className="logo">
            <span className="logo-icon">◈</span>
            <span className="logo-text">Blue<span className="logo-peak">peak</span></span>
          </div>
          <p className="footer-tagline">
            Managed IT solutions built for<br />
            professional services firms.
          </p>
        </div>

        <div className="footer-links">
          <div className="footer-col">
            <h4>Navigation</h4>
            <Link to="/">Home</Link>
            <Link to="/solutions">Solutions</Link>
            <Link to="/credentials">Credentials</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div className="footer-col">
            <h4>Services</h4>
            <span>PC Health Monitoring</span>
            <span>Workstation Setup</span>
            <span>Remote Support</span>
            <span>Cybersecurity</span>
          </div>
          <div className="footer-col">
            <h4>Industries</h4>
            <span>Law Firms</span>
            <span>Accounting Firms</span>
            <span>School Boards</span>
            <span>Enterprise</span>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <span>© {new Date().getFullYear()} Bluepeak IT Solutions. All rights reserved.</span>
          <span className="footer-mono">Uptime is not optional.</span>
        </div>
      </div>
    </footer>
  );
}
